import { render, staticRenderFns } from "./StepConfigForm.vue?vue&type=template&id=0df976e0&scoped=true"
import script from "./StepConfigForm.vue?vue&type=script&lang=js"
export * from "./StepConfigForm.vue?vue&type=script&lang=js"
import style0 from "./StepConfigForm.vue?vue&type=style&index=0&id=0df976e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df976e0",
  null
  
)

export default component.exports